module.exports = {"id":"137373","name":"Massimo Gobbi","rating":"73","photo":"./data/images/photos/4/137373.png","club":{"name":"Chievo Vérone","logo":"./data/images/clubs/ChievoVerone.png"},"positions":["DG"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/MassimoGobbi0.json
// module id = 2845
// module chunks = 0